export default __webpack_public_path__ + "static/media/hp.8e9dce67.jpg";